import { createFileRoute } from "@tanstack/react-router";
import { CurrenciesPage } from "@/components/registries/currencies-page.js";

export const Route = createFileRoute("/_authenticated/configuration/registries/currencies")({
  component: CurrenciesPage,
});
